import axios from '../utils/index';
import { Pat } from '@/typings/request';
const taskApi = {
    async getTaskList(params: Pat) {
        return axios.get(`/task/page`, { params });
    },
    async getAssignTaskList(params: Pat) {
        return axios.get(`/task/assign/tasker/list`, { params });
    },
    async assignTasker(taskerId: string, params: Pat) {
        return axios.get(`/task/assign/tasker/${taskerId}`, { params });
    },
    async tasklog(taskId: string, pageNum: number) {
        return axios.get(`/task/log/list/${taskId}`, { params: { pageNum, pageSize: 10 } });
    },
    async cancelTask(taskId: string) {
        return axios.get(`/task/cancel/job/${taskId}`);
    },
};
export default taskApi;
